<div class="main-wrapper">
  <div class="content">
    <div class="form-container">
      <img
        src="assets/svg/logos/saude_conectada_logo.svg"
        alt="Logo Saúde Conectada"
        class="logo"
      />

      <div class="texts">
        <h2>Link liberado.</h2>
        <p>
          Seu acesso à plataforma foi liberado.
          <br />
          Defina sua senha para começar a utilizar.
        </p>
      </div>

      <button
        matButton="filled"
        class="submit-button"
        style="width: 100%;"
        (click)="irParaDefinirSenha()"
      >
        Definir senha
      </button>
      <img
        src="assets/svg/logos/sesi_logo.svg"
        alt="Logo SESI"
        class="logo-sesi"
      />
    </div>
  </div>
</div>
